export default __webpack_public_path__ + "static/media/CCTVDropdown.1bea29f9.svg";